<template>
  <div class="agenda-page">
    <!-- Hero Section with Form -->
    <section class="hero-section">
      <div class="hero-container">
        <div class="hero-inner">
          <div class="content-grid">
          <!-- Left: Title -->
          <div class="title-column">
            <h1 class="main-title">
              February<br>
              2026<br>
              AGENDA
            </h1>
          </div>

          <!-- Middle: Form Card -->
          <div class="form-column">
            <div class="form-card">
              <h2 class="form-title">Access The Complete INTERNATIONAL EDU TRAVEL Guide</h2>

              <p class="form-description">
                Download the full agenda featuring 250+ speakers and 200+ sponsors shaping AI's next decade.
              </p>

              <p class="form-description">
                Plus get access to our intelligent matchmaking app to connect with the right partners and opportunities we will shift the form fields below and right above that we will add the content
              </p>

              <!-- Form -->
              <form class="agenda-form" @submit.prevent="submitForm">
                <div class="form-row">
                  <div class="form-group">
                    <label class="form-label">Business Email*</label>
                    <input
                      v-model="formData.email"
                      type="email"
                      class="form-input"
                      placeholder=""
                      required
                    />
                  </div>

                  <div class="form-group phone-group">
                    <label class="form-label">Phone number*</label>
                    <div class="phone-input-wrapper">
                      <select v-model="formData.countryCode" class="country-select">
                        <option value="+976">Mon</option>
                        <option value="+1">US</option>
                        <option value="+44">UK</option>
                        <option value="+971">UAE</option>
                      </select>
                      <input
                        v-model="formData.phone"
                        type="tel"
                        class="form-input phone-input"
                        placeholder="+976"
                        required
                      />
                    </div>
                  </div>
                </div>

                <button type="submit" class="submit-btn">
                  Download Agenda
                </button>
              </form>
            </div>
          </div>

 
        </div>
      </div>
      </div>

      <!-- Animated Carousel Rows -->
      <div class="carousel-section">
        <!-- Row 1 - Scrolling Left to Right -->
        <div class="carousel-track carousel-track-1">
          <div class="carousel-content">
            <div
              v-for="(item, index) in [...carouselRow1, ...carouselRow1]"
              :key="`row1-${index}`"
              class="carousel-badge"
            >
              {{ item }}
            </div>
          </div>
        </div>

        <!-- Row 2 - Scrolling Right to Left -->
        <div class="carousel-track carousel-track-2">
          <div class="carousel-content carousel-reverse">
            <div
              v-for="(item, index) in [...carouselRow2, ...carouselRow2]"
              :key="`row2-${index}`"
              class="carousel-badge"
            >
              {{ item }}
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Day Tabs Section -->
    <section class="tabs-section">
      <v-container>
        <v-tabs
          v-model="activeDay"
          color="#6320EE"
          slider-color="#6320EE"
          class="agenda-tabs"
        >
          <v-tab class="day-tab">
            <span class="tab-title-text">
              <div class="tab-content">
                <p class="tab-label">DAY 1:</p>
                <p class="tab-date">9th Feb</p>
              </div>
            </span>
          </v-tab>
          <v-tab class="day-tab">
            <span class="tab-title-text">
              <div class="tab-content">
                <p class="tab-label">DAY 2:</p>
                <p class="tab-date">10th Feb</p>
              </div>
            </span>
          </v-tab>
        </v-tabs>

        <!-- Sessions Content -->
        <v-tabs-items v-model="activeDay" class="tabs-items">
          <v-tab-item>
            <div class="sessions-list">
              <div
                v-for="(session, index) in day1Sessions"
                :key="`d1-${index}`"
                class="session-item"
              >
                <div class="session-time">{{ session.time }}</div>
                <div class="session-info">
                  <div v-if="session.tag" class="session-tag">{{ session.tag }}</div>
                  <h3 class="session-title">{{ session.title }}</h3>
                </div>
              </div>
            </div>
          </v-tab-item>

          <v-tab-item>
            <div class="sessions-list">
              <div
                v-for="(session, index) in day2Sessions"
                :key="`d2-${index}`"
                class="session-item"
              >
                <div class="session-time">{{ session.time }}</div>
                <div class="session-info">
                  <div v-if="session.tag" class="session-tag">{{ session.tag }}</div>
                  <h3 class="session-title">{{ session.title }}</h3>
                </div>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-container>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AgendaPage',
  data() {
    return {
      activeDay: 0,
      formData: {
        email: '',
        countryCode: '+976',
        phone: ''
      },
      topicBadges: [
        { text: 'Brain Machine Interface', icon: null },
        { text: 'LLM-based Applications', icon: '🤖' },
        { text: 'AI and Advanced Robotics', icon: null },
        { text: 'AI-Powered retail', icon: null },
        { text: 'Quantum Computing', icon: '⚛️' },
        { text: 'AI Processors', icon: '🧠' }
      ],
      carouselRow1: [
        'Brain Machine Interface',
        'LLM-based Applications',
        'AI and Advanced Robotics',
        'AI-Powered retail',
        'Quantum Computing',
        'AI Processors'
      ],
      carouselRow2: [
        'Responsible AI',
        'Intelligent Data and Analytics',
        'Supply Chain & logistics',
        'Generative AI',
        'AI in Cybersecurity',
        'Open-Source AI'
      ],
      day1Sessions: [
        { time: '08:30', title: 'Registration & Coffee' },
        { time: '09:30', tag: 'OPENING KEYNOTE', title: "Vision to Reality - Saudi Arabia's AI Revolution for Global Impact" },
        { time: '09:50', tag: 'HEADLINER', title: 'Meet AI in 2030: Transforming Development Pathways for a New Era in Saudi Arabia' },
        { time: '10:10', tag: 'HEADLINER', title: 'Future Intelligence: Future of Smart Machines and Human Collaboration' },
        { time: '10:30', tag: 'HEADLINER', title: 'From Theory to Practice: Real-World AGI Implementations and Their Transformative Power' },
        { time: '11:00', title: 'Networking Break' },
        { time: '11:30', tag: 'AI IN HEALTHCARE', title: 'Virtual Health: The AI-Powered Shift in Patient-Centric Care' },
        { time: '12:00', tag: 'PHARMACEUTICAL AI', title: "Pharma's Intelligence: Reduce AI Risk in a Heavily Regulated and Scrutinized Sector" },
        { time: '12:30', tag: 'AI IN HEALTHCARE', title: "Future Intelligence: AI's Role in Accelerating Drug Innovation" },
        { time: '13:00', title: 'Lunch Break' },
        { time: '14:00', tag: 'PANEL DISCUSSION', title: 'Could AI be your secret of expanding across the Middle East?' },
        { time: '14:30', tag: 'FUTURE TRENDS', title: "Predict, Diagnose, Act: AI's Revolution in Healthcare" },
        { time: '15:00', title: 'Coffee & Networking' },
        { time: '15:30', tag: 'ROUNDTABLE', title: 'Personalized Healing: Leading Tech, Data-Ownership and Patient Experience' }
      ],
      day2Sessions: [
        { time: '08:30', title: 'Registration & Morning Coffee' },
        { time: '09:00', tag: 'OPENING KEYNOTE', title: 'Transforming The Future with AI Innovation' },
        { time: '09:40', tag: 'HEADLINER', title: 'Accelerating Digital Transformation Through AI' },
        { time: '10:20', tag: 'PANEL', title: 'AI Ethics: Building Trust in Artificial Intelligence' },
        { time: '11:00', title: 'Networking Break' },
        { time: '11:30', tag: 'AI IN BUSINESS', title: 'Machine Learning at Scale: Real-World Applications' },
        { time: '12:10', tag: 'FUTURE INTELLIGENCE', title: 'The Future of Autonomous Systems' },
        { time: '12:50', title: 'Lunch & Startup Pitch Competition' },
        { time: '14:00', tag: 'EDUCATION', title: 'AI in Education: Transforming Learning Experiences' },
        { time: '14:40', tag: 'FINANCE', title: 'AI in Financial Services: Innovation and Risk Management' },
        { time: '15:20', title: 'Afternoon Refreshments' },
        { time: '16:00', tag: 'CLOSING KEYNOTE', title: 'AI for Humanity: Solving Global Challenges' },
        { time: '16:45', title: 'Closing Ceremony & Awards' }
      ]
    }
  },
  methods: {
    submitForm() {
      console.log('Form submitted:', this.formData)
      // Add form submission logic here
    }
  }
}
</script>

<style scoped>
/* Hero Section */
.hero-section {
  background-image: url(https://www.globalaishow.com/wp-content/uploads/2024/08/agenda-background.webp);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.hero-container {
  position: relative;
  z-index: 2;
  width: 100%;
  padding: 120px 10px 80px 10px;
}

.hero-inner {
  max-width: min(100%, 1140px);
  margin: 0 auto;
  width: 100%;
  padding: 0;
}

.content-grid {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 40px;
  align-items: center;
  padding: 0;
  width: 100%;
}

/* Title Column */
.title-column {
  flex: 1 1 auto;
  min-width: 300px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.main-title {
  margin: 0;
  line-height: 1.1;
  font-size: 80px;
  font-weight: 800;
  background: linear-gradient(135deg, #6320ee 0%, #a855f7 50%, #f1ebfb 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -2px;
  font-family: "BDO Grotesk", sans-serif;
  text-align: left;
}

/* Form Card */
.form-column {
  flex: 0 0 auto;
  width: 100%;
  max-width: 500px;
}

.form-card {
  background: #ffffff;
  padding: 45px 40px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
}

.form-title {
  font-size: 32px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 24px 0;
  line-height: 1.2;
  letter-spacing: -0.5px;
}

.form-description {
  font-size: 14px;
  color: #1a1a1a;
  line-height: 1.6;
  margin-bottom: 18px;
  font-weight: 400;
}

.agenda-form {
  margin-top: 32px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.form-label {
  font-size: 13px;
  font-weight: 400;
  color: #1a1a1a;
  margin-bottom: 8px;
  letter-spacing: 0px;
}

.form-input {
  padding: 14px 16px;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  font-size: 15px;
  font-family: inherit;
  background: #ffffff;
  width: 100%;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: #6320EE;
}

.phone-input-wrapper {
  display: flex;
  gap: 8px;
  width: 100%;
}

.country-select {
  padding: 14px 12px;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  font-size: 15px;
  background: #ffffff;
  cursor: pointer;
  min-width: 85px;
  max-width: 95px;
  font-weight: 400;
}

.country-select:focus {
  outline: none;
  border-color: #6320EE;
}

.phone-input {
  flex: 1;
}

.submit-btn {
  width: 100%;
  padding: 16px;
  background: #5d1fd4;
  border: none;
  color: #FFFFFF;
  font-size: 14px;
  line-height: 1;
  font-family: sans-serif;
  border-radius: 4px;
  font-weight: 700;
  cursor: pointer;
  text-transform: none;
  letter-spacing: 0px;
  box-shadow: none;
}

.submit-btn:hover {
  background: #6b2ee0;
}

/* Topic Badges Grid */
.badges-column {
  padding-top: 20px;
}



.topic-badge {
  background: rgba(99, 32, 238, 0.15);
  border: 1px solid rgba(99, 32, 238, 0.3);
  border-radius: 50px;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  cursor: pointer;
  min-height: 55px;
}

.topic-badge:hover {
  background: rgba(99, 32, 238, 0.25);
  border-color: rgba(99, 32, 238, 0.5);
  transform: translateY(-2px);
}

.badge-icon {
  font-size: 18px;
}

.badge-text {
  font-size: 14px;
  font-weight: 600;
  color: white;
  line-height: 1.3;
}

/* Animated Carousel */
.carousel-section {
  margin-top: 40px;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: hidden;
  width: 100%;
  max-width: 1140px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  z-index: 2;
}

.carousel-track {
  overflow: hidden;
  width: 100%;
  position: relative;
}

.carousel-content {
  display: flex;
  gap: 16px;
  animation: scroll-left 40s linear infinite;
  width: max-content;
}

.carousel-reverse {
  animation: scroll-right 40s linear infinite;
}

@keyframes scroll-left {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

@keyframes scroll-right {
  0% {
    transform: translateX(-50%);
  }
  100% {
    transform: translateX(0);
  }
}

.carousel-badge {
  background: rgba(30, 30, 40, 0.9);
  backdrop-filter: blur(10px);
  border: 1.5px solid rgba(99, 32, 238, 0.3);
  border-radius: 50px;
  padding: 14px 28px;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
  white-space: nowrap;
  flex-shrink: 0;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

/* Tabs Section */
.tabs-section {
  background: #ffffff;
  padding: 80px 0 100px;
  position: relative;
}

.tabs-section .v-container {
  max-width: 1400px !important;
}

.agenda-tabs {
  background: transparent !important;
  box-shadow: none;
  margin-bottom: 60px;
  border-bottom: 1px solid #e0e0e0;
}

.day-tab {
  text-transform: none !important;
  min-width: auto;
  padding: 0 20px 12px 0 !important;
  margin-right: 30px !important;
  border-radius: 0 !important;
  background: transparent !important;
  position: relative;
}

.day-tab.v-tab--active {
  background: transparent !important;
}

.day-tab.v-tab--active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 20px;
  height: 3px;
  background: #6320EE;
}

.tab-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.tab-title-text {
  display: block;
}

.tab-label {
  font-size: 13px;
  color: #999;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0;
  line-height: 1.4;
}

.v-tab--active .tab-label {
  color: #6320EE;
}

.tab-date {
  font-size: 16px;
  color: #999;
  font-weight: 600;
  margin: 0;
  line-height: 1.4;
}

.v-tab--active .tab-date {
  color: #6320EE;
}

/* Sessions */
.tabs-items {
  background: transparent !important;
}

.sessions-list {
  max-width: 100%;
  margin: 0 auto;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  overflow: hidden;
}

.session-item {
  display: grid;
  grid-template-columns: 100px 1fr;
  gap: 0;
  padding: 0;
  background: transparent;
  border-radius: 0;
  margin-bottom: 0;
  border-left: none;
  align-items: stretch;
  box-shadow: none;
  border-bottom: 1px solid #e8e8e8;
}

.session-time {
  font-size: 16px;
  font-weight: 600;
  color: #00C896;
  padding: 24px 20px 24px 20px;
  letter-spacing: 0;
  border-right: 1px solid #e8e8e8;
}

.session-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px 20px;
}

.session-tag {
  display: inline-block;
  background: transparent;
  color: #999;
  padding: 0;
  border-radius: 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  align-self: flex-start;
  box-shadow: none;
  margin-bottom: 4px;
}

.session-title {
  font-size: 16px;
  font-weight: 400;
  color: #1a1a1a;
  line-height: 1.5;
  margin: 0;
}

/* Responsive */
@media (max-width: 1200px) {
  .hero-inner {
    padding: 0 20px;
  }

  .content-grid {
    flex-direction: column;
    gap: 30px;
    align-items: center;
  }

  .title-column {
    text-align: left;
    width: 100%;
    justify-content: flex-start;
  }

  .main-title {
    font-size: 60px;
    line-height: 1.2;
    text-align: left;
  }

  .form-column {
    width: 100%;
    max-width: 600px;
  }
}

@media (max-width: 960px) {
  .hero-inner {
    padding: 0 20px;
  }

  .hero-container {
    padding: 80px 10px 60px 10px;
  }

  .main-title {
    font-size: 50px;
    line-height: 1.2;
  }

  .form-card {
    padding: 35px 30px;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .form-group {
    width: 100%;
  }

  .session-item {
    grid-template-columns: 80px 1px 1fr;
    gap: 0;
    padding: 0;
  }

  .day-tab {
    min-width: 150px;
    padding: 20px 30px !important;
  }
}

@media (max-width: 600px) {
  .hero-inner {
    padding: 0 10px;
  }

  .hero-container {
    padding: 60px 10px 40px 10px;
  }

  .content-grid {
    gap: 30px;
  }

  .main-title {
    font-size: 45px;
    line-height: 1.2;
    letter-spacing: -0.5px;
  }

  .form-card {
    padding: 28px 24px;
  }

  .form-title {
    font-size: 22px;
  }

  .form-column {
    width: 100%;
  }

  .carousel-badge {
    font-size: 13px;
    padding: 10px 20px;
  }

  .session-item {
    grid-template-columns: 70px 1fr;
  }

  .session-time {
    font-size: 14px;
    padding: 20px 12px;
  }

  .session-info {
    padding: 20px 16px;
  }

  .session-title {
    font-size: 15px;
  }
}
</style>
